<form [formGroup]="formCadastrar" (ngSubmit)="PesquisarPlanos()" aria-labelledby="form-title">
  <breadcrumb [paginas]="[
      {route:'/home',name:'Home'},
      {route:'/plano-melhoria/consulta',name:'PMCE'}
    ]" aria-label="Navegação de breadcrumb" />

  <!-- FILTRO ESCOLA -->
  <section class="section-filtro" aria-labelledby="filtro-escola-title">
    <div class="container">
      <div class="grupo-filter">
        <p><b>URE</b></p>
        <ng-select [items]="diretorias"
                   bindLabel="nomeDiretoria"
                   bindValue="codigoDiretoria"
                   placeholder="Selecione uma URE"
                   formControlName="codigoDiretoria"
                   name="codigoDiretoria"
                   [ngClass]="{ 'is-invalid': submitted && form.codigoDiretoria.errors }"
                   (change)="getEscolas()"
                   aria-describedby="diretoria-error">
        </ng-select>
        <div *ngIf="submitted && form.codigoDiretoria.errors" class="alert">
          <div *ngIf="form.codigoDiretoria.errors.required">
            * URE é obrigatório
          </div>
        </div>
      </div>

      <div class="grupo-filter">
        <p><b>Escola</b></p>
        <ng-select [items]="escolas"
                   bindLabel="nomeEscola"
                   bindValue="codigoEscola"
                   placeholder="Selecione uma Escola"
                   formControlName="codigoEscola"
                   name="codigoEscola"
                   aria-describedby="escola-error">
        </ng-select>
      </div>

      <!-- Botão Buscar -->
      <button type="submit" class="btn-search-filtro">
        <img src="../../../../assets/img/icons/icon-search.svg"
             alt="Pesquisar"
             title="Pesquisar" />
      </button>

    </div>
  </section>

  <!-- TITULO -->
  <section class="section-saudacao">
    <div class="container">
      <div class="row_registros">
        <h3 class="titulo-page">PMCE - Plano da Melhoria de Convivência Escolar</h3>
        <button
          type="button"
          class="btn_adicionar_registro"
          title="Cadastrar plano"
          (click)="navigateToCadastrarPlano()">
          <i aria-hidden="true" class="fa fa-plus"></i> Cadastrar Plano
        </button>
      </div>
    </div>
  </section>

  <section class="section-legenda">
    <div class="container">
      <div class="legenda-titulo">
        <p>Legenda</p>
      </div>
      <div class="legenda-calendario" aria-labelledby="legenda-title">
        <i class="fa-solid fa-eye" title="Visualizar"></i>
        <i class="fa-solid fa-arrows-rotate" title="Enviar para Validação"></i>
        <i class="fa-solid fa-check-square" title="Aprovar"></i>
        <i class="fa-solid fa-times" title="Devolver para ajustes"></i>
      </div>
    </div>
  </section>

  <section class="conteudo-principal" aria-labelledby="detalhes-chamado-title">
    <div class="container-conviva form-registro container-grid grid-pmce">
      <app-tabulator-table [tableData]="planosMelhoriaExibicao"
                           [columnNames]="colunasGrid"
                           [mostrarFiltro]="false"
                           [mostrarExportarHtml]="true"
                           [mostrarExportarExcel]="true"
                           [mostrarExportarPDF]="true"
                           [mostrarImprimir]="true"
                           [tipoRelatorio]="3"
                           [legendaHtml]="legendaEvidenciasGrid"
                           [orientacaoPortrait]="false"></app-tabulator-table>
    </div>
  </section>

</form>


<app-modal *ngIf="showCadastroModal" class="modal-cadastrar">
  <div class="container-conviva form-registro modal-envolvidos">
    <app-plano-melhoria-cadastro [planoMelhoria]="planoSelecionado"
                                 [ehModal]="true"
                                 [ehEdicao]="false"
                                 [tituloAcaoModal]="tituloAcaoModal"
                                 [statusPlano]="statusPlano"
                                 (planoAtualizado)="OnPlanoEvidenciasAtualizado($event)"
                                 (fechar)="FecharCadastroModal()">
    </app-plano-melhoria-cadastro>
  </div>
</app-modal>

<app-modal *ngIf="showAprovarModal">
  <div class="modal-plano-melhoria">  
    <div class="imagen">
      <img src="../../../../assets/img/elemento/elemento-aprovar.svg" alt="Aprovar" />
    </div>
    <div class="container-conviva form-registro modal-envolvidos">
      <div class="header-modal-calendario">
        <h2 class="titulo-page">
          Tem certeza de que deseja aprovar?
        </h2>
        <div class="row alert-attention">
          <i class="fa fa-exclamation-circle"></i>        
          <p>
            <strong>Atenção:</strong> Depois da aprovação, a única modificação permitida será a inclusão de ações e o envio de evidências.
          </p>
        </div>
        <h4>Detalhes</h4>
        <div class="card-detalhes">
          <p>
            Ano
          </p>
          <p>
            <strong>
              {{ planoSelecionado?.anoLetivo }}
            </strong>
          </p>
        </div>
        <div class="card-detalhes">
          <p>Escola</p>
          <p>
            <strong>
              {{ planoSelecionado?.nomeEscola }}
            </strong>
          </p>
        </div>
      </div>
      <div class="container-btns pt-5">
        <input type="button" class="btn_outline" value="Cancelar" (click)="FecharAprovarModal()" aria-label="Cancelar" />
        <input type="button" class="btn_primary" value="Confirmar" (click)="ConfirmarAprovacaoPlano()" aria-label="Confirmar" />
      </div>
    </div>
  </div>
</app-modal>

<app-modal *ngIf="showReprovarModal">
  <div class="modal-plano-melhoria">  
    <div class="imagen">
      <img src="../../../../assets/img/elemento/elemento-reprovar.svg" alt="Reprovar" />
    </div>
    <form [formGroup]="formModal" (submit)="ConfirmarReprovacaoPlano()">
      <div class="container-conviva form-registro modal-envolvidos">
        <div class="header-modal-calendario">
          <h2 class="titulo-page">
            Tem certeza de que deseja reprovar?
          </h2>
          <h4>Detalhes</h4>
          <div class="card-detalhes">
            <p>
              Ano
            </p>
            <p>
              <strong>
                {{ planoSelecionado?.anoLetivo }}
              </strong>
            </p>
          </div>
          <div class="card-detalhes">
            <p>Escola</p>
            <p>
              <strong>
                {{ planoSelecionado?.nomeEscola }}
              </strong>
            </p>
          </div>
        </div>
        <div>
          <div class="conteudo-textarea">
            <label for="dsTemas">
              Motivo da reprovação:
            </label>
            <textarea id="dsJustificativa"
                      name="dsJustificativa"
                      rows="6"
                      cols="50"
                      formControlName="dsJustificativa"
                      minlength="50"
                      (keyup)="OnChangeCountLettersJustificativa()"
                      [ngClass]="{ 'is-invalid': submitted && modalForm.dsJustificativa.errors }"
                      aria-describedby="descricao-error"></textarea>
            <p class="fs-5">Quantidade de caracteres atual: {{qtdeCaracteresJustificativa}}</p>
            <div *ngIf="submitted && modalForm.dsJustificativa.errors" class="alert">
              <div *ngIf="modalForm.dsJustificativa.errors?.required">
                *  Motivo da reprovação é obrigatório.
              </div>
              <div *ngIf="modalForm.dsJustificativa.errors?.minlength">
                * É obrigatório no mínimo digitar 150 caracteres.
              </div>
              <div *ngIf="modalForm.dsJustificativa.errors?.maxlength">
                * Maximo de caracteres é 1000.
              </div>
            </div>
          </div>
        </div>
        <div class="container-btns pt-5">
          <input type="button" class="btn_outline" value="Cancelar" (click)="FecharReprovarModal()" aria-label="Cancelar" />
          <input type="submit" class="btn_primary" value="Confirmar" aria-label="Confirmar" />
        </div>
      </div>
    </form>
  </div>
</app-modal>
